export const getNotificationText = (strings, type, entity = 'games') => {
  return {
    notificationBarTitle: strings[`notifications/${entity}/${type}/title`],
    notificationBarText: strings[`notifications/${entity}/${type}/text`],
  };
};
